export default "__VITE_ASSET__Ww8LviLT__"